import React from 'react';

export default function IconSettingTipjar() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 14.8336H5.5C4.85834 14.8336 4.33334 14.3086 4.33334 13.6669V9.19856C4.33334 8.69106 4.49667 8.20106 4.8 7.79856L6.08334 6.0894V4.92273H5.49417C5.17334 4.92273 4.91667 4.6544 4.91667 4.33356V3.75606C4.91667 3.43523 5.17917 3.17273 5.5 3.17273H12.5C12.8208 3.17273 13.0833 3.43523 13.0833 3.75606V4.33356C13.0833 4.6544 12.8267 4.9169 12.5058 4.9169H11.9167V6.0894L13.2 7.79856C13.5033 8.20106 13.6667 8.69106 13.6667 9.19856V13.6669C13.6667 14.3086 13.1417 14.8336 12.5 14.8336Z"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.08334 4.91666H11.9167"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9 7.83334V12.5"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.4583 8.41666H8.41666C7.9325 8.41666 7.54166 8.80749 7.54166 9.29166C7.54166 9.77582 7.9325 10.1667 8.41666 10.1667H9.58333C10.0675 10.1667 10.4583 10.5575 10.4583 11.0417C10.4583 11.5258 10.0675 11.9167 9.58333 11.9167H7.54166"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
